import { useQuery } from '@tanstack/react-query';
import { fetchPaymentMethods } from '@/renderer/services/paymentMethodService';

export function usePaymentMethods() {
  return useQuery({
    queryKey: ['accounting', 'payment-methods'],
    queryFn: async () => {
      const result = await fetchPaymentMethods();
      if (!result.success) {
        throw new Error('Failed to fetch payment methods');
      }
      return result.data ?? [];
    },
    staleTime: 5 * 60 * 1000,
  });
}
